export default {
  merchant_type_1: 'Persona física',
  merchant_type_2: 'Empresa / Persona jurídica',
  merchant_status_1: 'Activo',
  merchant_status_2: 'Inactivo',
  merchant_origin_1: 'Contrato directo de plataforma',
  merchant_origin_2: 'Contrato vía agente / afiliado',
  id_num_type_1: 'Documento nacional de identidad (Recomendado)',
  id_num_type_2: 'Licencia de conducir',
  id_num_type_3: 'Pasaporte',
  id_num_type_4: 'Postal ID',
  id_num_type_5: 'PRC (Tarjeta de Identificación Profesional)',
  id_num_type_6: 'ID del Sistema de Seguridad Social (SSS)',
  id_num_type_7: 'UMID (Documento de Identificación Multipropósito Unificado)',
  id_num_type_8: 'Credencial de elector',
  id_num_type_9: 'PhilHealth ID',
  id_num_type_10: 'Documento de Identificación del Número de Identificación Fiscal (TIN)',
  fee_type_1: 'Tarifa basada en porcentaje',
  fee_type_2: 'Monto fijo',
  fee_structure_1: 'Tarifa plana',
  fee_structure_2: 'Tarifa escalonada por niveles',
  merchant_product_1: 'Cobro / Pay-in',
  merchant_product_2: 'Desembolso / Payout',
  merchant_product_4: 'Reembolso',
  pay_trans_status_1: 'No pagado',
  pay_trans_status_2: 'Pago exitoso',
  pay_trans_status_3: 'Pago fallido',
  pay_trans_status_4: 'Pago cancelado',
  pay_trans_status_5: 'Cancelación de pago en proceso',
  po_trans_status_0: 'En creación',
  po_trans_status_1: 'Esperando pago',
  po_trans_status_2: 'Procesando pago',
  po_trans_status_3: 'Pago exitoso',
  po_trans_status_4: 'Pago fallido',
  po_trans_status_5: 'Procesando pago',
  po_trans_status_99: 'Reembolso completado',
  refunding_status_0: 'Esperando reembolso',
  refunding_status_1: 'Reembolso en proceso',
  refunding_status_2: 'Reembolso exitoso',
  refunding_status_3: 'Reembolso fallido',
  refunding_status_4: 'Reembolso parcial en proceso',
  refunding_status_5: 'Reembolso parcial exitoso',
  refunding_status_6: 'Reembolso cancelado',
  repayment_status_1: 'Pago en proceso',
  repayment_status_2: 'Reembolso de deuda exitoso',
  repayment_status_3: 'Reembolso de deuda fallido',
  repayment_status_4: 'Cerrado',
  withdraw_trans_status_4: 'Pendiente de procesar',
  withdraw_trans_status_1: 'Retiro en proceso',
  withdraw_trans_status_2: 'Retiro exitoso',
  withdraw_trans_status_3: 'Retiro fallido',
  withdraw_trans_status_5: 'Esperando reintento',
  withdraw_trans_status_6: 'Reintentando',
  withdraw_trans_status_7: 'Pendiente de cotización',
  withdraw_trans_status_8: 'Pendiente de confirmación',
  balance_type_1: 'Liquidación de cobros',
  balance_type_2: 'Desembolso / Payout',
  balance_type_3: 'Recarga de cuenta',
  balance_type_4: 'Retiro de fondos',
  balance_type_5: 'Reembolso por Desembolso fallido',
  balance_type_6: 'Transferencia recibida de comercio asociado',
  balance_type_7: 'Transferencia enviada a comercio asociado',
  balance_type_8: 'Liquidación inmediata D0',
  balance_type_9: 'Monto congelado',
  balance_type_10: 'Monto descongelado',
  balance_type_11: 'Reversión',
  balance_type_12: 'Abono por reversión',
  balance_type_13: 'Abono por ajuste de errores',
  balance_type_14: 'Cargo por ajuste de errores',
  balance_type_15: 'Liquidación de comisión de cobro',
  balance_type_16: 'Liquidación de comisión de pago',
  balance_type_17: 'Deducción de comisión (Reversión)',
  balance_type_18: 'Deducción de comisión (Reembolso por dispersión fallida)',
  balance_type_19: 'Reembolso posterior al pago',
  balance_type_20: 'Error en el reembolso',
  balance_type_21: 'Deducción de comisión (Reembolso de pago)',
  balance_type_22: 'Reembolso por retiro fallido',
  balance_type_23: 'Egreso por conversión de divisas (FX)',
  balance_type_24: 'Ingreso por conversión de divisas (FX)',
  balance_type_25: 'Cancelación de conversión FX (Egreso)',
  balance_type_26: 'Cancelación de conversión FX (Ingreso)',
  balance_type_27: 'Cobro Db',
  balance_type_28: 'Recarga NSDS',
  balance_type_29: 'Pago de la comisión de servicio de NSDS',
  balance_type_30: 'Reembolso de la comisión de servicio de NSDS',
  balance_type_31: 'Egreso por reparto de fondos (Split)',
  balance_type_32: 'Ingreso por reparto de fondos (Split)',
  balance_type_33: 'Egreso por devolución del reparto de fondos (Split)',
  balance_type_34: 'Ingreso por devolución del reparto de fondos (Split)',
  balance_type_35: 'Comisión por liquidación anticipada',
  balance_type_36: 'Verificación de tarjeta',
  balance_type_37: 'Reembolso por verificación de tarjeta fallida',
  balance_type_38: 'Deducción NSDS',
  funds_source_1: 'Inversiones',
  funds_source_2: 'Empleo',
  funds_source_3: 'Negocio',
  funds_source_4: 'Herencia',
  funds_source_99: 'Otros',
  recharge_status_1: 'Recarga en proceso',
  recharge_status_2: 'Recarga completada',
  recharge_status_3: 'Recarga fallida',
  recharge_status_4: 'Rechazada',
  upload_status_1: 'Subida exitosa',
  upload_status_2: 'Conciliación confirmada',
  deal_status_0: 'no conciliado',
  deal_status_1: 'no conciliado',
  deal_status_2: 'Conciliación en proceso',
  deal_status_3: 'Conciliación completada',
  po_trans_type_1: 'Desembolso por API',
  po_trans_type_2: 'Desembolso masivo mediante archivo',
  po_trans_type_3: 'Retiro de fondos',
  pay_trans_type_1: 'Pago por API',
  pay_trans_type_2: 'Operación de recarga de comercio',
  ticket_status_1: 'Sin procesar',
  ticket_status_2: 'En proceso',
  ticket_status_3: 'Procesado',
  large_payment_status_1: 'Procesando',
  large_payment_status_2: 'Completado',
  large_payment_status_3: 'Fallido',
  large_payment_status_4: 'Reembolso exitoso',
  institute_type_1: 'Canal de cobro (Pay-in)',
  institute_type_2: 'Canal de pago (Payout)',
  institute_rate_type_1: 'Monto fijo',
  institute_rate_type_2: 'Porcentaje fijo',
  institute_rate_type_3: 'Monto fijo escalonado',
  institute_rate_type_4: 'Porcentaje fijo escalonado',
  institute_rate_type_5: 'El menor entre monto fijo y porcentaje',
  institute_rate_type_6: 'El mayor entre monto fijo y porcentaje',
  action_type_1: 'Egreso / Cargo',
  action_type_2: 'Ingreso / Abono',
  channel_code_1: 'GCASH_STATIC_VA',
  channel_code_2: 'PAYMAYA_STATIC_VA',
  channel_code_3: '7ELEVEN_STATIC_VA',
  channel_code_4: 'MLH_STATIC_VA',
  channel_code_5: 'RDP_STATIC_VA',
  channel_code_6: 'QRPH_STATIC_QR',
  channel_code_7: 'QRPH_DYNAMIC_QR',
  channel_code_8: 'QRPH_HYBRID_QR',
  channel_code_9: 'INSTA_TRANSFER_ACC',
  channel_code_10: 'PESONET_TRANSFER_ACC',
  settlement_type_1: 'Liquidación automática',
  settlement_type_2: 'Liquidación manual',
  withdraw_type_1: 'Retiro manual',
  withdraw_type_2: 'Retiro automático',
  auto_withdraw_type_1: 'Plazo de retiro',
  auto_withdraw_type_2: 'Monto del retiro',
  va_account_aduit_status_1: 'En proceso de revisión',
  va_account_aduit_status_2: 'Aprobado',
  va_account_aduit_status_3: 'Rechazado',
  switch_status_1: 'Habilitado',
  switch_status_2: 'Deshabilitado',
  mch_audit_status_1: 'Pendiente de revisión',
  mch_audit_status_2: 'Devuelto',
  mch_audit_status_3: 'Rechazado',
  mch_audit_status_4: 'Aprobado',
  read_flag_1: 'No leído',
  read_flag_2: 'Leído',
  jt_order_status_1: 'Pendiente de pago',
  jt_order_status_2: 'Pagado',
  jt_order_status_3: 'Cancelado',
  beneficiary_audit_1: 'En revisión',
  beneficiary_audit_2: 'Aprobado',
  beneficiary_audit_3: 'Rechazado',
  beneficiary_audit_4: 'Devuelto',
  beneficiary_audit_5: 'Expirado',
  single_payout_payment_type_1: 'Pago de bajo valor',
  single_payout_payment_type_2: 'Pago de alto valor',
  transaction_settlement_status_1: 'Liquidado',
  transaction_settlement_status_2: 'Pendiente de liquidación',
  checkout_status_1: 'No pagado',
  checkout_status_2: 'Pagado',
  checkout_status_3: 'Cerrado',
  fx_transaction_type_1: 'Conversión de divisas (FX)',
  fx_transaction_type_2: 'Cancelación de conversión de divisas',
  common_status_1: 'En proceso',
  common_status_2: 'Exitoso',
  common_status_3: 'Fallido',
  beneficiary_account_type_0: 'Banco',
  beneficiary_account_type_1: 'Promptpay',
  beneficiary_account_type_2: 'Billetera electrónica',
  beneficiary_account_type_3: 'SBP',
  beneficiary_type_0: 'Número de documento de identidad',
  beneficiary_type_1: 'Número de teléfono móvil',
  beneficiary_type_2: 'Cuenta bancaria',
  beneficiary_type_3: 'Número de tarjeta',
  loan_status_1: 'Pendiente de revisión',
  loan_status_2: 'Pendiente de desembolso',
  loan_status_3: 'Desembolsado',
  loan_status_4: 'Transacción rechazada',
  loan_type_1: 'Préstamo para consumo',
  loan_type_2: 'Préstamo en efectivo',
  repay_method_1: 'Pago manual',
  repay_method_2: 'Débito automático',
  repay_method_3: 'Pago combinado',
  bill_status_2: 'En proceso',
  bill_status_3: 'Liquidado',
  bill_status_4: 'Vencido',
  loan_bill_status_1: 'En proceso',
  loan_bill_status_2: 'Liquidado',
  loan_bill_status_3: 'Vencido',
  credit_debit_1: 'Ingreso de fondos',
  credit_debit_2: 'Egreso de fondos',
  benefit_address: 'Dirección del beneficiario',
  receiver_relation_map_1: 'Proveedor de servicios',
  receiver_relation_map_2: 'Tienda',
  receiver_relation_map_3: 'Empleado',
  receiver_relation_map_4: 'Propietario del negocio',
  receiver_relation_map_5: 'Socio comercial',
  receiver_relation_map_6: 'Oficina central',
  receiver_relation_map_7: 'Titular de la marca',
  receiver_relation_map_8: 'Distribuidor',
  receiver_relation_map_9: 'Usuario',
  receiver_relation_map_10: 'Proveedor',
  receiver_relation_map_11: 'Personalizado',
  receiver_type_map_1: 'Comercio de PayCools',
  receiver_type_map_2: 'Cuenta bancaria',
  receiver_type_map_3: 'Billetera electrónica',
  split_status_map_1: 'Pendiente de reparto de fondos',
  split_status_map_2: 'Reparto de fondos exitoso',
  split_status_map_3: 'Reparto de fondos fallido',
  checkout_order_status_1: 'Pendiente de pago',
  checkout_order_status_2: 'Pagado',
  checkout_order_status_3: 'Cerrado',
  authorization_status_1: 'No autorizado',
  authorization_status_2: 'Autorizado',
  card_account_status_1: 'Activo',
  card_account_status_2: 'Inactivo',
  card_account_status_3: 'Congelado',
  card_account_status_4: 'Cerrado',
  card_order_status_0: 'Pendiente',
  card_order_status_1: 'En proceso',
  card_order_status_2: 'Exitoso',
  card_order_status_3: 'Fallido',
  card_name_match_result_0: 'No verificado',
  card_name_match_result_1: 'Coincide',
  card_name_match_result_2: 'No coincide',
  card_account_type_1: 'Cuenta bancaria',
  card_account_type_2: 'Billetera electrónica',
  template_type_1: 'Mantenimiento del canal',
  template_type_2: 'Calendario de días festivos',
  template_type_3: 'Pedido de riesgo',
  template_type_4: 'Ajuste de tarifas',
  template_type_5: 'Alerta de saldo',
  template_type_6: 'Disputa de tarjeta',
  template_type_99: 'Other',
  template_type_1_desc: 'Cambios en el estado del canal, avisos de mantenimiento, etc.',
  template_type_2_desc: 'Avisos de días festivos, horarios no laborables, etc.',
  template_type_3_desc: 'Notificaciones sobre la gestión de solicitudes de revisión de operaciones de riesgo',
  template_type_4_desc: 'Notificaciones sobre ajustes de tarifas',
  template_type_5_desc: 'Se enviará un correo cuando el saldo sea inferior al importe de alerta. «Notificaciones en la aplicación» solo controla las notificaciones de esta cuenta y no afecta a los correos. Para desactivar la alerta, borre el importe.',
  template_type_5_desc_sub: 'Los importes de alerta los configura la cuenta principal.',
  template_type_6_desc: 'Notificaciones relacionadas con la gestión de disputas',
  template_type_99_desc: 'Notificaciones de otros tipos'
}
